import { generateMock } from '../generateMock';
import { GenerateArrayMockOptions } from '../interfaces';

export function generateArrayMock<Dto extends Record<keyof Dto, any> = any>(options: GenerateArrayMockOptions): Dto[] {
    const { fields, count } = options;
    return Array.from({ length: count }, () => generateMock<Dto>(fields));
}
